<template>
  <el-form class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-flex tw-gap-x-6 tw-gap-y-3 tw-items-start">
    <i-form-item :label="$t('adm.audit.filter.by_user')">
      <el-select
        :model-value="filters.action_user"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('action_user', payload)"
      >
        <el-option-group
          v-for="group in users"
          :key="group.role_name"
          :label="$capitalize(group.role_name)"
        >
          <el-option
            v-for="user in group.users"
            :key="user.id"
            :label="user.fullname"
            :value="user.id"
          />
        </el-option-group>
      </el-select>
    </i-form-item>

    <i-form-item>
      <MultiSelectWithSearch
        v-model="filters.action_name"
        option-object-label-key="name"
        :options="actionNames"
        :label="$t('adm.audit.filter.action')"
        :handle-change="(payload) => updateFilter('action_name', payload)"
      />
    </i-form-item>

    <i-form-item :label="$t('adm.audit.filter.severity')">
      <el-select
        :model-value="filters.severity"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('severity', payload)"
      >
        <el-option
          v-for="user in severities"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        />
      </el-select>
    </i-form-item>

    <div class="tw-flex tw-gap-3 tw-w-full">
      <i-form-item :label="$t('common.fields.date_from')">
        <el-date-picker
          v-model="filters.action_date_from"
          type="date"
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY HH:mm:ss"
          @change="(payload) => updateFilter('action_date_from', payload)"
        />
      </i-form-item>
      <i-form-item :label="$t('common.fields.date_until')">
        <el-date-picker
          v-model="filters.action_date_to"
          type="date"
          placeholder=""
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY HH:mm:ss"
          @change="(payload) => updateFilter('action_date_to', payload)"
        />
      </i-form-item>
    </div>
  </el-form>
</template>

<script>
import MultiSelectWithSearch from '@/components/shared/MultiSelectWithSearch.vue';
import { mapState } from 'vuex';

export default {
  name: 'AuditLogsFilters',
  components: { MultiSelectWithSearch },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.logs.audit.filters,
      internalUsers: (state) => state.v2.admin.cms.internal.users.allUsers,
      clientsUsers: (state) => state.v2.admin.cms.clients.users.allUsers,
      actionNames: (state) => state.v2.shared.enums.admin_audit_events,
      severities: (state) => state.v2.shared.enums.audit_severities,
    }),
    users() {
      return [
        {
          role_name: this.$t('user.role.internal.name'),
          users: this.internalUsers,
        },
        {
          role_name: this.$t('user.role.client.name'),
          users: this.clientsUsers,
        },
      ];
    },
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/cms/logs/audit/updateFilter', { field, payload });
    },
  },
};
</script>
